<template>
  <div class="Chat" style="display: flex;">
    <div class="idback" v-if="!dataConnection">
      <div class="idarea">
        <textarea id="kari-id"  placeholder="じぶんのあいことば"></textarea>
        <button id="name" v-on:click="camera">けってい</button><br>
        <textarea id="kari-id2"  placeholder="あいてのあいことば"></textarea>
        <button id="name2" v-on:click="makeCall">けってい</button>
      </div>
      <diV class="how">
        1人目の人：上の欄に自分の合言葉を入れて赤い決定ボタンを押してから、待っていてください。<br>
        2人目の人：①上の欄に自分の合言葉を入れて赤い決定ボタンを押します。<br>
                 ②下の欄に相手の合言葉を入れて黒い決定ボタンを押します。
      </div>
    </div>

    <div class="left">
      <div>
        <video id="my-video" autoplay muted playsinline></video><br>
        <video id="their-video"></video>
      </div>
    </div>

    <div class="right" v-if="dataConnection">
      <div class="content2">
        <div id="messages">
          <div v-if="dataConnection">
            <div class="boxchat scrolly">
              <pre>
                <template v-for="msg in messages">
                  {{ msg }}
                </template>
              </pre>
            </div>
            <textarea id="kari" v-model="message"></textarea>
            <button id="name2" v-on:click="send">おくる</button>
          </div>
        </div>

        <div class="container2">
          <article class="article-item box">
            <div class="article-inside">
              <button calss="cat" v-on:click="addLast_tisai_a"><img src="../assets/cat_tisai_a.png"></button>
              <audio ref="audioElm_tisai_a" src="../sound/tisai_a.mp3"></audio>
            </div>
          </article>
          <article class="article-item box">
            <div class="article-inside">
              <button calss="cat" v-on:click="addLast_tisai_ya" class="image"><img src="../assets/cat_tisai_ya.png" alt=""></button>
              <audio ref="audioElm_tisai_ya" src="../sound/tisai_ya.mp3"></audio>
            </div>
          </article>
          <article class="article-item box">
            <div class="article-inside">
              <button calss="cat" v-on:click="addLast_wa" class="image"><img src="../assets/cat_wa.png" alt=""></button>
              <audio ref="audioElm_wa" src="../sound/wa.mp3"></audio>
            </div>
          </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ra"><img src="../assets/cat_ra.png"></button>
            <audio ref="audioElm_ra" src="../sound/ra.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ya"><img src="../assets/cat_ya.png"></button>
            <audio ref="audioElm_ya" src="../sound/ya.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ma"><img src="../assets/cat_ma.png"></button>
            <audio ref="audioElm_ma" src="../sound/ma.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ha"><img src="../assets/cat_ha.png"></button>
            <audio ref="audioElm_ha" src="../sound/ha.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_na"><img src="../assets/cat_na.png"></button>
            <audio ref="audioElm_na" src="../sound/na.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ta"><img src="../assets/cat_ta.png"></button>
            <audio ref="audioElm_ta" src="../sound/ta.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_sa"><img src="../assets/cat_sa.png"></button>
            <audio ref="audioElm_sa" src="../sound/sa.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ka"><img src="../assets/cat_ka.png"></button>
            <audio ref="audioElm_ka" src="../sound/ka.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_a"><img src="../assets/cat_a.png"></button>
            <audio ref="audioElm_a" src="../sound/a.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_tisai_i"><img src="../assets/cat_tisai_i.png"></button>
            <audio ref="audioElm_tisai_i" src="../sound/tisai_i.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_tisai_yu"><img src="../assets/cat_tisai_yu.png"></button>
            <audio ref="audioElm_tisai_yu" src="../sound/tisai_yu.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_wo"><img src="../assets/cat_wo.png"></button>
            <audio ref="audioElm_wo" src="../sound/wo.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ri"><img src="../assets/cat_ri.png"></button>
            <audio ref="audioElm_ri" src="../sound/ri.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_yu"><img src="../assets/cat_yu.png"></button>
            <audio ref="audioElm_yu" src="../sound/yu.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_mi"><img src="../assets/cat_mi.png"></button>
            <audio ref="audioElm_mi" src="../sound/mi.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_hi"><img src="../assets/cat_hi.png"></button>
            <audio ref="audioElm_hi" src="../sound/hi.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ni"><img src="../assets/cat_ni.png"></button>
            <audio ref="audioElm_ni" src="../sound/ni.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ti"><img src="../assets/cat_ti.png"></button>
            <audio ref="audioElm_ti" src="../sound/ti.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_si"><img src="../assets/cat_si.png"></button>
            <audio ref="audioElm_si" src="../sound/si.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ki"><img src="../assets/cat_ki.png"></button>
            <audio ref="audioElm_ki" src="../sound/ki.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_i"><img src="../assets/cat_i.png"></button>
            <audio ref="audioElm_i" src="../sound/i.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_tisai_u"><img src="../assets/cat_tisai_u.png"></button>
            <audio ref="audioElm_tisai_u" src="../sound/tisai_u.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_tisai_yo"><img src="../assets/cat_tisai_yo.png"></button>
            <audio ref="audioElm_tisai_yo" src="../sound/tisai_yo.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_nn"><img src="../assets/cat_nn.png"></button>
            <audio ref="audioElm_nn" src="../sound/nn.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ru"><img src="../assets/cat_ru.png"></button>
            <audio ref="audioElm_ru" src="../sound/ru.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_yo"><img src="../assets/cat_yo.png"></button>
              <audio ref="audioElm_yo" src="../sound/yo.mp3"></audio>
            </div>
          </article>
          <article class="article-item box">
            <div class="article-inside">
              <button calss="cat" v-on:click="addLast_mu"><img src="../assets/cat_mu.png"></button>
            <audio ref="audioElm_mu" src="../sound/mu.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_hu"><img src="../assets/cat_hu.png"></button>
            <audio ref="audioElm_hu" src="../sound/hu.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_nu"><img src="../assets/cat_nu.png"></button>
            <audio ref="audioElm_nu" src="../sound/nu.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_tu"><img src="../assets/cat_tu.png"></button>
            <audio ref="audioElm_tu" src="../sound/tu.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_su"><img src="../assets/cat_su.png"></button>
            <audio ref="audioElm_su" src="../sound/su.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ku"><img src="../assets/cat_ku.png"></button>
            <audio ref="audioElm_ku" src="../sound/ku.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_u"><img src="../assets/cat_u.png"></button>
            <audio ref="audioElm_u" src="../sound/u.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_tisai_e"><img src="../assets/cat_tisai_e.png"></button>
            <audio ref="audioElm_tisai_e" src="../sound/tisai_e.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_tisai_tu"><img src="../assets/cat_tisai_tu.png"></button>
            <audio ref="audioElm_tisai_tu" src="../sound/tisai_tu.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_dakuten"><img src="../assets/cat_dakuten.png"></button>
            <audio ref="audioElm_dakuten" src="../sound/dakuten.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_re"><img src="../assets/cat_re.png"></button>
            <audio ref="audioElm_re" src="../sound/re.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_cat"><img src="../assets/cat.png"></button>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_me"><img src="../assets/cat_me.png"></button>
            <audio ref="audioElm_me" src="../sound/me.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button v-on:click="addLast_he"><img src="../assets/cat_he.png"></button>
            <audio ref="audioElm_he" src="../sound/he.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ne"><img src="../assets/cat_ne.png"></button>
            <audio ref="audioElm_ne" src="../sound/ne.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_te"><img src="../assets/cat_te.png"></button>
            <audio ref="audioElm_te" src="../sound/te.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_se"><img src="../assets/cat_se.png"></button>
            <audio ref="audioElm_se" src="../sound/se.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ke"><img src="../assets/cat_ke.png"></button>
            <audio ref="audioElm_ke" src="../sound/ke.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_e"><img src="../assets/cat_e.png"></button>
            <audio ref="audioElm_e" src="../sound/e.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_tisai_o"><img src="../assets/cat_tisai_o.png"></button>
            <audio ref="audioElm_tisai_o" src="../sound/tisai_o.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_nobasu"><img src="../assets/cat_nobasu.png"></button>
            <audio ref="audioElm_nobasu" src="../sound/nobasu.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_handakuten"><img src="../assets/cat_handakuten.png"></button>
            <audio ref="audioElm_handakuten" src="../sound/handakuten.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ro"><img src="../assets/cat_ro.png"></button>
            <audio ref="audioElm_ro" src="../sound/ro.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_cat"><img src="../assets/cat.png"></button>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_mo"><img src="../assets/cat_mo.png"></button>
            <audio ref="audioElm_mo" src="../sound/mo.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ho"><img src="../assets/cat_ho.png"></button>
            <audio ref="audioElm_ho" src="../sound/ho.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_no"><img src="../assets/cat_no.png"></button>
            <audio ref="audioElm_no" src="../sound/no.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_to"><img src="../assets/cat_to.png"></button>
            <audio ref="audioElm_to" src="../sound/to.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_so"><img src="../assets/cat_so.png"></button>
            <audio ref="audioElm_so" src="../sound/so.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_ko"><img src="../assets/cat_ko.png"></button>
            <audio ref="audioElm_ko" src="../sound/ko.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_o"><img src="../assets/cat_o.png"></button>
            <audio ref="audioElm_o" src="../sound/o.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_0"><img src="../assets/cat_0.png"></button>
            <audio ref="audioElm_0" src="../sound/0.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_1"><img src="../assets/cat_1.png"></button>
            <audio ref="audioElm_1" src="../sound/1.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_2"><img src="../assets/cat_2.png"></button>
            <audio ref="audioElm_2" src="../sound/2.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_3"><img src="../assets/cat_3.png"></button>
            <audio ref="audioElm_3" src="../sound/3.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_4"><img src="../assets/cat_4.png"></button>
            <audio ref="audioElm_4" src="../sound/4.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_5"><img src="../assets/cat_5.png"></button>
            <audio ref="audioElm_5" src="../sound/5.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_6"><img src="../assets/cat_6.png"></button>
            <audio ref="audioElm_6" src="../sound/6.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_7"><img src="../assets/cat_7.png"></button>
            <audio ref="audioElm_7" src="../sound/7.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_8"><img src="../assets/cat_8.png"></button>
            <audio ref="audioElm_8" src="../sound/8.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_9"><img src="../assets/cat_9.png"></button>
            <audio ref="audioElm_9" src="../sound/9.mp3"></audio>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_cat"><img src="../assets/cat.png"></button>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside">
            <button calss="cat" v-on:click="addLast_cat"><img src="../assets/cat.png"></button>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside" id="read_delete">
            <button calss="cat" v-on:click="addLast_delete"><img src="../assets/delete/cat_delete.png"></button>
          </div>
        </article>
        <article class="article-item box">
          <div class="article-inside" id="read_delete">
            <button calss="cat" v-on:click="addLast_1delete"><img src="../assets/delete/cat_1delete.png"></button>
          </div>
        </article>
      </div>
      </div>   
    </div>
  </div>  
</template>

<script>
  const Peer = require('skyway-js');
export default {
  name: 'Chat',
  components: {},
  data() {
    return {
      peer: null,
      myId: null,
      destId: null,
      dataConnection: null,
      message: '',
      messages: [],
      text: '',
    };
  },

  methods: {
    camera: function() {
      let localStream;
      // カメラ映像取得
      navigator.mediaDevices.getUserMedia({video: true, audio: true})
      .then( stream => {
        // 成功時にvideo要素にカメラ映像をセットし、再生
        const videoElm = document.getElementById('my-video')
        videoElm.srcObject = stream;
        videoElm.play();
        console.log(stream.getAudioTracks());
        // 着信時に相手にカメラ映像を返せるように、グローバル変数に保存しておく
        localStream = stream;
        this.localStream = localStream;
      }).catch( error => {
        // 失敗時にはエラーログを出力
        console.error('mediaDevice.getUserMedia() error:', error);
        return;
      });
      // 入力した文字をエンコード
      const kariId = document.getElementById('kari-id').value;
      const peerId = encodeURIComponent(kariId).replace(/%/g, "");
      alert(`あなたのあいことばは${kariId}です`);
      //Peer作成 Stringの中身がPeerIDになる
      this.peer = new Peer(String(peerId),{
        key: '8facd484-c850-43cc-925d-4f5b98f39680',
        debug: 3
      });
      this.peer.on('open', () => {
        this.myId = this.peer.id;
      });
      //着信処理
      this.peer.on('connection', dataConnection => {
        console.log('connect');
        this.dataConnection = dataConnection;
        this.setEventListenerChat();
        this.theirId = dataConnection.remoteId;
      });
      //着信処理
      this.peer.on('call', call => {
        call.answer(this.localStream);
        this.setEventListener(call);
      });
      this.peer.on('error', err => {
        console.error({ err, msg: 'error' });
        alert(err.message);
      });

      this.peer.on('error', err => {
        console.error({ err, msg: 'error' });
        alert(err.message);
      });
    },
    makeCall() {
      console.log('makecall');
      const kariId2 = document.getElementById('kari-id2').value;
      const theirId = encodeURIComponent(kariId2).replace(/%/g, "");
      alert(`あいてのあいことばは${kariId2}です`);
      // DataConnection(テキストメッセージなど) の確立
      this.dataConnection = this.peer.connect(theirId);
      this.setEventListenerChat();

      const call = this.peer.call(theirId, this.localStream);
      this.setEventListener(call);
    },
    send() {
      this.dataConnection.send(this.message);
      this.messages.unshift(`わたし: ${this.message}`);
    },
    setEventListenerChat() {
      this.dataConnection.on('open', () => {
        console.log("aaaaa");
      });
      this.dataConnection.on('data', data => {
        console.log("bbbbb");
        this.messages.unshift(`あいて: ${data}`);
      });
      this.dataConnection.on('close', () => {
        this.dataConnection = null;
      });
      this.dataConnection.on('error', () => {
        console.log({ on: 'error' });
      });
    },
    setEventListener: function(call) {
      call.on('stream', stream => {
        // video要素にカメラ映像をセットして再生
        const videoElm = document.getElementById('their-video')
        videoElm.srcObject = stream;
        videoElm.play();  
      });    
      this.peer.on('error', err => {
        alert(err.message);
      });
      this.peer.on('close', () => {
        alert('通信が切断しました。');
      });
    },


    addLast_1delete: function() {
      this.message = this.message.slice(0,-1);
    },
    addLast_0: function () {
      this.showText = !this.showText
      this.message += '0';
    },
    addLast_1: function () {
      this.showText = !this.showText
      this.message += '1';
    },
    addLast_2: function () {
      this.showText = !this.showText
      this.message += '2';
    },
    addLast_3: function () {
      this.showText = !this.showText
      this.message += '3';
    },
    addLast_4: function () {
      this.showText = !this.showText
      this.message += '4';
    },
    addLast_5: function () {
      this.showText = !this.showText
      this.message += '5';
    },
    addLast_6: function () {
      this.showText = !this.showText
      this.message += '6';
    },
    addLast_7: function () {
      this.showText = !this.showText
      this.message += '7';
    },
    addLast_8: function () {
      this.showText = !this.showText
      this.message += '8';
    },
    addLast_9: function () {
      this.showText = !this.showText
      this.message += '9';
    },
    addLast_a: function () {
      this.showText = !this.showText
      this.message += 'あ';
    },
    addLast_ka: function () {
      this.showText = !this.showText
      this.message += 'か';
    },
    addLast_sa: function () {
      this.showText = !this.showText
      this.message += 'さ';
    },
    addLast_ta: function () {
      this.showText = !this.showText
      this.message += 'た';
    },
    addLast_na: function () {
      this.showText = !this.showText
      this.message += 'な';
    },
    addLast_ha: function () {
      this.showText = !this.showText
      this.message += 'は';
    },
    addLast_ma: function () {
      this.showText = !this.showText
      this.message += 'ま';
    },
    addLast_ya: function () {
      this.showText = !this.showText
      this.message += 'や';
    },
    addLast_ra: function () {
      this.showText = !this.showText
      this.message += 'ら';
    },
    addLast_wa: function () {
      this.showText = !this.showText
      this.message += 'わ';
    },
    addLast_tisai_ya: function () {
      if('き' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'きゃ';
      }
      else if('し' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'しゃ';
      }
      else if('ち' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'ちゃ';
      }
      else if('に' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'にゃ';
      }
      else if('ひ' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'ひゃ';
      }
      else if('み' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'みゃ';
      }
      else if('り' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'りゃ';
      }
      else if('ぢ' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'ぢゃ';
      }
      else if('び' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'びゃ';
      }
      else if('ぴ' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'ぴゃ';
      }
      else if('じ' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'じゃ';
      }
      else if('ぎ' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'ぎゃ';
      }
    },
    addLast_i: function () {
      this.showText = !this.showText
      this.message += 'い';
    },
    addLast_ki: function () {
      this.showText = !this.showText
      this.message += 'き';
    },
    addLast_si: function () {
      this.showText = !this.showText
      this.message += 'し';
    },
    addLast_ti: function () {
      this.showText = !this.showText
      this.message += 'ち';
    },
    addLast_ni: function () {
      this.showText = !this.showText
      this.message += 'に';
    },
    addLast_hi: function () {
      this.showText = !this.showText
      this.message += 'ひ';
    },
    addLast_mi: function () {
      this.showText = !this.showText
      this.message += 'み';
    },
    addLast_yu: function () {
      this.showText = !this.showText
      this.message += 'ゆ';
    },
    addLast_ri: function () {
      this.showText = !this.showText
      this.message += 'り';
    },
    addLast_wo: function () {
      this.showText = !this.showText
      this.message += 'を';
    },
    addLast_tisai_yu: function () {
      if('き' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'きゅ';
      }
      else if('し' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'しゅ';
      }
      else if('ち' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'ちゅ';
      }
      else if('に' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'にゅ';
      }
      else if('ひ' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'ひゅ';
      }
      else if('み' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'みゅ';
      }
      else if('り' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'りゅ';
      }
      else if('び' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'びゅ';
      }
      else if('ぴ' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'ぴゅ';
      }
      else if('じ' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'じゅ';
      }
      else if('ぢ' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'ぢゅ';
      }
      else if('ぎ' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'ぎゅ';
      }
    },
    addLast_tisai_yo: function () {
      if('き' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'きょ';
      }
      else if('し' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'しょ';
      }
      else if('ち' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'ちょ';
      }
      else if('に' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'にょ';
      }
      else if('ひ' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'ひょ';
      }
      else if('み' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'みょ';
      }
      else if('り' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'りょ';
      }
      else if('び' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'びょ';
      }
      else if('ぴ' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'ぴょ';
      }
      else if('じ' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'じょ';
      }
      else if('ぢ' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'ぢょ';
      }
      else if('ぎ' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'ぎょ';
      }
    },
    addLast_nn: function () {
      this.showText = !this.showText
      this.message += 'ん';
    },
    addLast_ru: function () {
      this.showText = !this.showText
      this.message += 'る';
    },
    addLast_yo: function () {
      this.showText = !this.showText
      this.message += 'よ';
    },
    addLast_mu: function () {
      this.showText = !this.showText
      this.message += 'む';
    },
    addLast_hu: function () {
      this.showText = !this.showText
      this.message += 'ふ';
    },
    addLast_nu: function () {
      this.showText = !this.showText
      this.message += 'ぬ';
    },
    addLast_tu: function () {
      this.showText = !this.showText
      this.message += 'つ';
    },
    addLast_su: function () {
      this.showText = !this.showText
      this.message += 'す';
    },
    addLast_ku: function () {
      this.showText = !this.showText
      this.message += 'く'
    },
    addLast_u: function () {
    this.showText = !this.showText
    this.message += 'う';
    },
    addLast_tisai_tu: function () {
      this.showText = !this.showText
      this.message += 'っ';
    },
    addLast_dakuten: function () {
      if('か' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'が';
      }
      else if('き' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'ぎ';
      }
      else if('く' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'ぐ';
      }
      else if('け' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'げ';
      }
      else if('こ' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'ご';
      }
      else if('さ' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'ざ';
      }
      else if('し' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'じ';
      }
      else if('す' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'ず';
      }
      else if('せ' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'ぜ';
      }
      else if('そ' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'ぞ';
      }
      else if('た' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'だ';
      }
      else if('ち' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'ぢ';
      }
      else if('つ' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'づ';
      }
      else if('て' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'で';
      }
      else if('と' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'ど';
      }
      else if('は' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'ば';
      }
      else if('ひ' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'び';
      }
      else if('ふ' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'ぶ';
      }
      else if('へ' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'べ';
      }
      else if('ほ' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'ぼ';
      }
      else if('か' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'が';
      }
      else if('き' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'ぎ';
      }
      else if('く' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'ぐ';
      }
      else if('け' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'げ';
      }
      else if('こ' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'ご';
      }
    },
    addLast_re: function () {
      this.showText = !this.showText
      this.message += 'れ';
    },
    addLast_cat: function () {
    this.showText = !this.showText
    this.message += '';
    },
    addLast_me: function () {
      this.showText = !this.showText
      this.message += 'め';
    },
    addLast_he: function () {
      this.showText = !this.showTextd
      this.message += 'へ';
    },
    addLast_ne: function () {
      this.showText = !this.showText
      this.message += 'ね';
    },
    addLast_te: function () {
      this.showText = !this.showText
      this.message += 'て';
    },
    addLast_se: function () {
      this.showText = !this.showText
      this.message += 'せ';
    },
    addLast_ke: function () {
      this.showText = !this.showText
      this.message += 'け';
    },
    addLast_e: function () {
      this.showText = !this.showText
      this.message += 'え';
    },
    addLast_nobasu: function () {
      this.showText = !this.showText
      this.message += 'ー';
    },
    addLast_handakuten: function () {
      if('は' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'ぱ';
      }
      else if('ひ' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'ぴ';
      }
      else if('ふ' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'ぷ';
      }
      else if('へ' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'ぺ';
      }
      else if('ほ' === this.message.slice(-1)){
        this.showText = !this.showText
        this.message = this.message.slice(0,-1);
        this.message += 'ぽ';
      }
    },
    addLast_ro: function () {
      this.showText = !this.showText
      this.message += 'ろ';
    },
    addLast_mo: function () {
      this.showText = !this.showText
      this.message += 'も';
    },
    addLast_ho: function () {
      this.showText = !this.showText
      this.message += 'ほ';
    },
    addLast_no: function () {
      this.showText = !this.showText
      this.message += 'の';
    },
    addLast_to: function () {
      this.showText = !this.showText
      this.message += 'と';
    },
    addLast_so: function () {
      this.showText = !this.showText
      this.message += 'そ';
    },
    addLast_ko: function () {
      this.showText = !this.showText
      this.message += 'こ';
    },
    addLast_o: function () {
      this.showText = !this.showText
      this.message += 'お';
    },
    addLast_tisai_a: function () {
      this.showText = !this.showText
      this.message += 'ぁ';
    },
    addLast_tisai_i: function () {
      this.showText = !this.showText
      this.message += 'ぃ';
    },
    addLast_tisai_u: function () {
      this.showText = !this.showText
      this.message += 'ぅ';
    },
    addLast_tisai_e: function () {
      this.showText = !this.showText
      this.message += 'ぇ';
    },
    addLast_tisai_o: function () {
      this.showText = !this.showText
      this.message += 'ぉ';
    },
    addLast_delete: function () {
      this.showText = !this.showText
      this.message = ''
    },
  }
}
</script>



<style scoped>
.Chat{
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

#my-video{
  width: 350px;
}

#their-video{
  width: 350px;
}

#kari-id2{
  background-color: white;
}

#kari-id{
  background-color: white;
}

#kari{
  background-color: #ddd;
}

.boxchat{
  width:500px;
  height:100px;
  margin:0 auto;
  background:#ffffff;
}

#chat{
  position:relative;
  top: 10px;
}

.scrolly{
  overflow:scroll;
  overflow-y:scroll;
}

.idarea{
  background-color: #ccdce5;
  width:600px;
  padding:20px;

}
.idback{
  background-color: transparent;
  top:150px;
  width:700px;
  margin:200px auto;
  margin-left:200px;
}
.content2{
  background-color: #ccdce5;
  position: relative;
}

#read_delete {
  width: 250%;
}

.content2 {
  margin: 0 auto;
  padding: 30px 10px;
  /* 外枠の大きさ */
  max-width: 580px;
  /* border: 1px solid black; */
  min-height: 610px;
}

/* 記事全ての枠の設定 */
.container2 {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  /* 記事折り返し設定 */
  margin: 0px auto 80 auto 0px auto 80 auto;
}

.article-item {
  /* 記事アイテムの一つの大きさ */
  width: 8.3%;
  height: auto;
  margin-bottom: 0px;
}

.article-item button img{
  /* 画像は親要素に対して100%にする */
  width: 100%;
  height: 100%;
}

.article-item p {
  padding: 0px 10px;
}

#text{
  background: white;
  height: 60px;
  font-size: 45px;
}

table{
    width:100;
    text-align: left;
}
table th{
  padding: 12px;
  border-bottom: 2px solid darkgrey;
}
table tb{
    padding: 12px;
}
table tr:nth-of-type(even){
    background-color: rgba(0, 0, 255, 0.1);
}

.left{
  flex-wrap: wrap;
  justify-content: space-around;
  display: inline-flex;
  align-items: flex-start;
}

.right{
  flex-wrap: wrap;
  justify-content: space-around;
  display: inline-flex;
  align-items: flex-start;
}

.cat{
    cursor: pointer;
    padding: 3px 3px;
    border-radius: 6px;
    color: #ccdce5;
    background-color: #ccdce5;
    transition: background-color .2s
}

.cat:hover{
    border: 0px;
    color: #ffffff;
    border-color: #ffffff;
    background-color: #000000;
}

.cat:active{
    border-color: #ccdce5;
    background-color: #ccdce5;
}

.content2 button{
    cursor: pointer;
    padding: 3px 3px;
    border-radius: 6px;
    color: #ccdce5;
    background-color: #ccdce5;
    transition: background-color .2s
}

.content2 button:hover{
    border: 0px;
    color: #ffffff;
    border-color: #ffffff;
    background-color: #ffffff;
}

.content2 button:active{
    border-color: #ccdce5;
    background-color: #ccdce5;
}

.content2 button:disabled{
    border-style: none;
    opacity: .5;
    pointer-events: none;
}

.content2 button.name{
  background-color: #846ca4;
}


.single2{
    background-color: #ccdce5;
}

table{
    width:100;
    text-align: left;
}
table th{
  padding: 12px;
  border-bottom: 2px solid darkgrey;
}
table tb{
    padding: 12px;
}
table tr:nth-of-type(even){
    background-color: rgba(0, 0, 255, 0.1);
}
button{
    outline: none;
    cursor: pointer;
    padding: 3px 3px;
    border-radius: 6px;
    color: #ccdce5;
    border: 0px;
    border: none;
    background-color: #ccdce5;
    transition: background-color .2s
}

button:hover{
    background-color: #ffffff;
    outline: none;
}

button:active{
    background-color: #ffffff;
    outline: none;
}

button:disabled{
    opacity: .5;
    pointer-events: none;
    outline: none;
}

.right{
  background-color: #ccdce5;
  color: #ccdce5;
}

#name{
  width: 140px;
  height: 40px;
  font-size: 30px;
  color:#ffffff;
  background: #ee5d58;
}

#name2{
  width: 140px;
  height: 40px;
  font-size: 30px;
  color:#ffffff;
  background: #62717a;
}

.how{
  text-align:left;
}

#messages{
  font-size:24px;
}

.boxchat{
  background-color: #ffffff;
  color: #000000;
}
</style>